import clsx from 'clsx';

export const useStyles = (isTabSelected: boolean = false) => {
  return {
    tabList: clsx("gap-6 w-full relative p-0 border-b", {
      "border-divider": !isTabSelected,
      "border-green-500": isTabSelected,
    }),
    cursor: "w-full bg-vistagreen",
    tab: "max-w-fit px-0 h-12 border-vistagreen",
    tabContent: "group-data-[selected=true]:text-vistagreen",
    panel: ["w-full rounded-lg"],
    label: ["text-[10px] uppercase text-vistagrey/60 z-0"],
    input: [],
    inputWrapper: [""],
    mainWrapper: [],
    base: ["pt-2 w-full"],
  };
};